import React, { useEffect, useState } from "react";
import Layout from "../../components/layouts/layout";
import DataService from "../../services/api/data_services";
import { BASE_SITE_URL } from "../../shared/constants";
import ogimage from "../../assets/Images/ogImages/whitepaper@2x.png";

// Modern components
import WhitePapersHeroBanner from "../../components/ModernArticles/WhitePapersHeroBanner";
import ArticlesGridSection from "../../components/ModernArticles/ArticlesGridSection";
import ArticlesCTASection from "../../components/ModernArticles/ArticlesCTASection";
import "../../components/ModernArticles/modernArticlesPage.scss";

const WhitePaperList = () => {
  const [whitePapers, setWhitePapers] = useState([]);
  const [rawData, setRawData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [hasLoadError, setHasLoadError] = useState(false);

  const loadWhitePapers = (pageToLoad, append = false) => {
    setIsLoading(true);
    setHasLoadError(false);
    DataService.getData(
      `/admin/api/post?page=${pageToLoad}&page_id=1&type=White Paper`
    )
      .then((response) => {
        const papers = response?.data || [];
        setWhitePapers((currentPapers) =>
          append ? [...currentPapers, ...papers] : papers
        );
        setRawData(response || {});
        setPage(pageToLoad);
        setIsLoading(false);
      })
      .catch(() => {
        setHasLoadError(true);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    loadWhitePapers(1);
  }, []);

  return (
    <Layout
      seo={{
        title: "Insights | White Papers | DigiRyte",
        ogtitle: "Insights | White Papers | DigiRyte",
        description:
          "A collection of our best thinking on strategy, software consultation, product development and innovation.",
        ogimage: ogimage,
        ogurl: `${BASE_SITE_URL}/insights/white-papers`,
      }}
    >
      <div className="modern-articles-page">
        <WhitePapersHeroBanner
          subtitle="Deep-dive research and strategic analysis on technology trends, digital transformation, and enterprise software solutions."
          breadcrumbs={[
            { label: "Home", to: "/" },
            { label: "Insights", to: "/insights" },
            { label: "White Papers" },
          ]}
          totalPapers={whitePapers.length || 10}
        />

        {isLoading ? (
          <div className="articles-loading-state body-container">
            <div className="loading-grid">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="loading-card-skeleton">
                  <div className="skeleton-image" />
                  <div className="skeleton-content">
                    <div className="skeleton-tag" />
                    <div className="skeleton-title" />
                    <div className="skeleton-title skeleton-title--short" />
                    <div className="skeleton-desc" />
                    <div className="skeleton-desc skeleton-desc--short" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <ArticlesGridSection
            articles={whitePapers}
            hasMore={rawData.has_more}
            onLoadMore={() => loadWhitePapers(page + 1, true)}
            isLoading={false}
            contentLabel="White Papers"
            emptyTitle={
              hasLoadError
                ? "White papers are temporarily unavailable"
                : "No white papers found"
            }
            emptyDescription={
              hasLoadError
                ? "We could not reach the content service. Please try again shortly."
                : "Check back later for new research and analysis."
            }
          />
        )}

        <ArticlesCTASection />
      </div>
    </Layout>
  );
};

export default WhitePaperList;
